import SimpleSchema from "simpl-schema";

const UUID = {
  type: String,
  regEx: new RegExp("[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}"),
};

const OptionalString = {
  type: String,
  optional: true,
};

const OptionalYesOrNo = {
  type: String,
  optional: true,
  allowedValues: ["yes", "no"],
  defaultValue: "no",
};

const OptionalNumber = {
  type: Number,
  optional: true,
  defaultValue: 0,
};

const OptionalNumberNullable = {
  type: Number,
  optional: true,
};

const OptionalInteger = {
  type: SimpleSchema.Integer,
  optional: true,
  defaultValue: 0,
};

const OptionalIntegerNullable = {
  type: SimpleSchema.Integer,
  optional: true,
};

const OptionalBoolean = {
  type: Boolean,
  optional: true,
  defaultValue: false,
};

const OptionalBooleanNullable = {
  type: Boolean,
  optional: true,
};

const IsoDate = {
  type: String,
  regEx: /\d{4}-\d{2}-\d{2}/,
  optional: true,
};

const OptionalIsoDate = {
  type: String,
  regEx: /\d{4}-\d{2}-\d{2}/,
  optional: true,
};

const IsoDateTime = {
  type: String,
  regEx: /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}\w{1}/,
};

const OptionalIsoDateTime = {
  type: String,
  regEx: /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}\w{1}/,
  optional: true,
};

export {
  IsoDate,
  IsoDateTime,
  UUID,
  OptionalString,
  OptionalNumber,
  OptionalInteger,
  OptionalBoolean,
  OptionalIsoDate,
  OptionalIsoDateTime,
  OptionalYesOrNo,
  OptionalNumberNullable,
  OptionalIntegerNullable,
  OptionalBooleanNullable,
};
